// ----------------------------------------------------------------------

const shape = {
    borderRadius: 0,
    borderRadiusSm: 0,
    borderRadiusMd: 0,
};

export default shape;
